import { GetAgenticLogicOrgExclusionsResponseBodyType } from "@intelligems/ig-types/functions/agentic-logic/exclusions/get";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

const getAgenticLogicExclusions = async () => {
  const resp = await api.get<GetAgenticLogicOrgExclusionsResponseBodyType>(
    `/v2/agentic-logic/exclusions`
  );
  return resp.data;
};

/**
 * Org-scoped singleton — the org comes from auth context, so there are no path
 * params. Orgs that never saved exclusions read as all-empty lists.
 */
export const useAgenticLogicExclusions = () => {
  return useQuery<GetAgenticLogicOrgExclusionsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.exclusions(),
    queryFn: async () => getAgenticLogicExclusions(),
  });
};
